import { Injectable } from '@angular/core'
import { TranslateService } from '@ngx-translate/core'
import { Title } from '@angular/platform-browser'

@Injectable({
  providedIn: 'root',
})
export class TitleService {
  constructor(
    private translateService: TranslateService,
    private title: Title
  ) {}

  updateTitleWithObject(objectId: number, objectName: string, baseTitleKey: string, fallbackToId: boolean = true) {
    const baseTitle = this.translateService.instant(baseTitleKey)

    let title = baseTitle
    if (objectName) {
      title += ' ' + objectName
    } else if (objectId) {
      title += ' ' + objectId
    }
    title += ' - Depoto'

    if (window['companyName'] && window['companyName'].length) {
      title += ' [' + window['companyName'] + ']'
    }

    this.title.setTitle(title)
  }

  // updateTitleWithId(id: string, baseTitleKey: string) {
  //   const baseTitle = this.translateService.instant(baseTitleKey)
  //   let title = `${baseTitle} ${id} - Depoto`
  //   if (window['companyName'] && window['companyName'].length) {
  //     title += ` [${window['companyName']}]`
  //   }
  //   this.title.setTitle(title)
  // }
}
